import { IPagination } from './common'
import { IUser } from './user'

export const MEMBER_SOURCE_LINGSHOUTONG = 1

export interface IMemberGroup {
    id: number
    name: string
    description: string
    status: number
    is_default?: boolean
}

export interface IMemberGroupListItem extends IMemberGroup {
    member_count: number
}

export interface IMemberBenefit {
    benefit: number
    is_on: boolean
    if_has: boolean
    discount_rate?: number
    multiplier?: number
}

export interface IMemberBenefits {
    benefit_member_discount?: IMemberBenefit | null
    benefit_member_price?: IMemberBenefit | null
    benefit_deduction_points?: IMemberBenefit | null
    benefit_broadcast?: IMemberBenefit | null
    benefit_recharge_bonus?: IMemberBenefit | null
    benefit_point_booster?: IMemberBenefit | null
}

export interface IMemberLevelSummary {
    id: number
    level: number
    name: string
    experience_threshold?: number
    status: number
}

export interface IMemberLevelDetail {
    id: number
    level: number
    name: string
    experience_threshold: number
    experience_deduction: number
    expiration: number
    status?: number
    benefits?: IMemberBenefits | null
}

export interface IMember {
    id: number
    name: string
    phone: string
    birthday?: string
    card_code?: string
    balance: string | number
    bonus?: string | number
    available_balance?: string | number
    chain_coin?: string | number
    points?: number
    experience?: number
    create_time?: string
    date_leveled_up?: string
    accumulated_recharge?: string | number
    accumulated_consume?: string | number
    accumulated_consume_count?: number
    total_recharge_amount?: string | number
    total_recharge_times?: number
    total_consume_amount?: string | number
    total_consume_times?: number
    is_svip?: boolean
    is_miniapp_blacklisted?: boolean
    miniapp_blacklist_level?: number
    svip_expire_time?: string | null
    source?: number
    group?: IMemberGroup
    level?: IMemberLevelSummary
    user?: IUser
    inviter?: {
        id: number
        name: string
    } | null
    shop?: {
        id: number
        name: string
    } | null
}

export interface IMemberListResponse {
    member_count: number
    member_list: IMember[]
    pagination: IPagination
}

export type IMemberListOrderBy =
    | 'id'
    | 'birthday'
    | 'balance'
    // Backend request sort key for the response field `points`.
    | 'point'
    | 'accumulated_recharge'
    | 'accumulated_consume'
    | 'accumulated_consume_count'

export interface IMemberListParams {
    page: number
    limit: number
    keyword?: string
    member_filter?: Array<{
        filter_type?: number
        group_ids?: number[]
        member_levels?: number[]
        member_pay?: number[]
        member_types?: number[]
        other_filter?: number[]
        balance_min?: number
        balance_max?: number
        points_min?: number
        points_max?: number
    }>
    order_by?: IMemberListOrderBy
    desc?: boolean | number
}

export interface IRecordListResponse<T> {
    records: T[]
    pagination: IPagination
}
